import { useTranslation } from 'react-i18next'
import React from 'react'

import { Text, Title } from '../../../../components/presentation/Text'
import Panel from '../../../../components/structure/Panel'
import { formatDate } from '@btime/helpers'

const SchedulingPanel = ({ serviceOrder }) => {
  const { t } = useTranslation('serviceOrders')
  if (!serviceOrder.scheduling) return false

  const scheduling = formatDate('DD/MM/YYYY HH:mm', serviceOrder.scheduling)

  return (
    <Panel lineBorder mediumPadding>
      <Title size="h6">{t('show.scheduling')}</Title>
      <Text>{scheduling}</Text>
    </Panel>
  )
}

export default SchedulingPanel
